module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-thread-timeline"
  }, [_c('div', {
    ref: "stickyCarrier",
    class: _vm.stickyClasses,
    style: (_vm.stickyStyle)
  }, [_vm._t("topAnchor", [_c('button', {
    staticClass: "top-anchor-btn anchor-btn",
    attrs: {
      "title": _vm.startDateStatus
    },
    on: {
      "click": function($event) {
        _vm.goToFirstPost()
      }
    }
  }, [(_vm.startDate) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.formatShortDate(_vm.startDate)) + "\n                ")]) : _c('span', [_vm._v("\n                    Start\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onSliderMouseDown($event)
      }
    }
  }, [_c('div', {
    ref: "sliderTrack",
    staticClass: "slider-track"
  }), _vm._v(" "), _c('div', {
    ref: "sliderThumb",
    staticClass: "slider-thumb",
    style: (_vm.sliderThumbStyle),
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onSliderThumbMouseDown($event)
      }
    }
  }, [_c('div', {
    staticClass: "slider-thumb-bar"
  }), _vm._v(" "), _vm._t("sliderThumbLabel", [_c('div', {
    staticClass: "slider-thumb-label"
  }, [(_vm.posts.length > 0) ? _c('div', [_vm._v("\n                            " + _vm._s(Math.floor(_vm.currentIndex) + 1) + "\n                            /\n                            " + _vm._s(_vm.posts.length) + "\n                        ")]) : _c('div', [_vm._v("0 / 0")]), _vm._v(" "), (_vm.currentDate) ? _c('div', {
    attrs: {
      "title": _vm.formatFullDate(_vm.currentDate)
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.formatShortDate(_vm.currentDate)) + "\n                        ")]) : _c('div', [_c('em', [_vm._v("No date")])])])])], 2)]), _vm._v(" "), _vm._t("bottomAnchor", [_c('button', {
    staticClass: "bottom-anchor-btn anchor-btn",
    attrs: {
      "title": _vm.lastDateStatus
    },
    on: {
      "click": function($event) {
        _vm.goToLastPost()
      }
    }
  }, [(_vm.lastDate) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.formatShortDate(_vm.lastDate)) + "\n                ")]) : _c('span', [_vm._v("\n                    Last\n                ")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00c0c81c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/thread-timeline.vue
// module id = 1933
// module chunks = 2